import SaveOrganizationWorkflowOptions from '@Application/Organizations/Workflows/Commands/SaveOrganizationWorkflowOptions';
import saveOrganizationWorkflowOptions from '@Application/Organizations/Workflows/saveOrganizationWorkflowOptions';
import { PermissionEnum } from '@Application/Security/Roles';
import ignoreHandledError from '@UI/Helpers/ignoreHandledError';
import CheckboxTile from '@UI/Pages/Administration/DocumentGroups/DocumentGroupEdit/Shared/CheckboxTile';
import SectionCard from '@Guidelines/Component/SectionCard';
import useHasPermission from '@UI/Providers/PermissionProvider/useHasPermission';
import * as React from 'react';
import { useDispatch } from '@verclam/synapse';

type Props = {
	readonly organizationId: number;
	readonly workflowKey: string;
	readonly separatesSpeakers: boolean;
};

/**
 * Leaf block: whether the chain attributes each speaking turn to a speaker. Saved at once; the
 * option is reversible, so it asks for no confirmation.
 */
const SpeakerSeparationSection: React.FC<Props> = ({ organizationId, workflowKey, separatesSpeakers }) => {
	const dispatch = useDispatch();
	const canWrite = useHasPermission(PermissionEnum.ORGANIZATION_WRITE);
	const [isSaving, setIsSaving] = React.useState(false);

	const handleSeparatesSpeakersChange = React.useCallback(
		(checked: boolean) => {
			setIsSaving(true);

			dispatch(
				saveOrganizationWorkflowOptions(
					new SaveOrganizationWorkflowOptions(organizationId, workflowKey, checked),
				),
			)
				.catch(ignoreHandledError)
				.finally(() => setIsSaving(false));
		},
		[dispatch, organizationId, workflowKey],
	);

	return (
		<SectionCard
			title="Séparation des interlocuteurs"
			description="Après la transcription, une étape attribue chaque tour de parole à un interlocuteur. Désactivée, l’étape est sautée : la transcription reste exploitable pour les documents."
		>
			<CheckboxTile
				name="separatesSpeakers"
				label="Séparer les interlocuteurs"
				checked={separatesSpeakers}
				disabled={!canWrite || isSaving}
				onChange={handleSeparatesSpeakersChange}
			/>
		</SectionCard>
	);
};

export default SpeakerSeparationSection;
